module.exports = __webpack_public_path__ + "img/robotics_solutions.a344a8b8.jpg";